<template>
    <div class="main-page">
        <div class="login-logo">
            <img class="login-logo-img" :src="require('../../assets/login/logo.png')" />
        </div>
        <div class="tag-box">
            <div class="tag-left tag-active">{{GLOBAL.lanLocal['login-low'] }}</div>
            <img class="tag-split" :src="require('../../assets/login/split.png')" />
            <div class="tag-right" @click="changeTag()">{{
                GLOBAL.lanLocal['regnow'] }}</div>
        </div>
        <div class="login-info">
            <div id="name-box" class="login-info-item" @click="nameFocus">
                <div class="v-box">
                    <input class="v-input" :placeholder="GLOBAL.lanLocal['account']" ref="loginname" type="text"
                        @focus="nameFocus" @blur="nameBlur" @input="nameInput" v-model="loginname" />
                </div>
            </div>
            <div class="msg-box">
                <div class="login-info-message error-info">{{ nameinfo }}</div>
            </div>
            <div id="passcode-box" class="login-info-item" @click="passcodeFocus">
                <div class="v-box">
                    <input class="v-input" :placeholder="GLOBAL.lanLocal['passcode']" ref="passcode" type="password"
                        @focus="passcodeFocus" @blur="passcodeBlur" @input="passcodeInput" v-if="!isEye" v-model="passcode" />
                    <input class="v-input" :placeholder="GLOBAL.lanLocal['passcode']" ref="passcode" type="text"
                        @focus="passcodeFocus" @blur="passcodeBlur" @input="passcodeInput" v-else v-model="passcode" />
                </div>
                <span class="v-icon mdi" :class="eyeClass" v-if="!isEye" @click="changeEye">
                    <img class="eye-img" :src="require('../../assets/login/pwd-normal.png')" />
                </span>
                <span class="v-icon mdi" :class="eyeClass" v-else @click="changeEye">
                    <img class="eye-img" :src="require('../../assets/login/pwd-show.png')" />
                </span>
            </div>
            <div class="msg-box">
                <div class="login-info-message error-info">{{ passcodeinfo }}</div>
            </div>
            <div class="bar-box">
                <div class="left-box">
                    <img class="remember-img" v-if="isRemember" @click="changeRemember"
                        :src="require('../../assets/login/selected.png')" />
                    <img class="remember-img" v-else @click="changeRemember"
                        :src="require('../../assets/login/normal.png')" />
                    <span class="keep-login">{{ GLOBAL.lanLocal['keeplogin'] }}</span>
                </div>
                <span class="forget-passcode" @click="toForgot">{{ GLOBAL.lanLocal['forgotpasscode'] }}?</span>
            </div>
            <div class="button-box">
                <input class="login-button"
                    :class="nameempty || nameerror || passcodeempty || passcodeerror ? 'login-button-disable' : ''"
                    type="button" @click="doLogin" :value="GLOBAL.lanLocal['login']" />
            </div>
        </div>
    </div>
</template>
  
<script>
import md5 from 'js-md5';
import loadFile from "../../api/loadFile.js"
import AES from "../../common/AES.js"
import { doPost } from '../../api/api.js'
import decodeApiLan from '../../api/decodeApiLan.js'
export default {
    name: 'login',
    data() {
        return {
            isEye: false,
            isRemember: true,
            loginname: '',
            passcode: '',
            nameerror: false,
            namefocus: false,
            nameempty: true,
            nameinfo: '',
            passcodeerror: false,
            passcodefocus: false,
            passcodeempty: true,
            passcodeinfo: '',
            innerHeight: 0,
        }
    },
    created() {
        this.innerHeight = window.innerHeight - 60
    },
    computed: {
        loginClass() {
            return {
                'error-info': this.nameerror,
                'normal-info': !this.nameerror && this.namefocus,
                'v-label-active': this.namefocus || !this.nameempty
            }
        },
        passcodeClass() {
            return {
                'error-info': this.passcodeerror,
                'normal-info': !this.passcodeerror && this.passcodefocus,
                'v-label-active': this.passcodefocus || !this.passcodeempty
            }
        },
        eyeClass() {
            return {
                'error-info': this.passcodeerror,
                'normal-info': !this.passcodeerror && this.passcodefocus
            }
        }
    },
    methods: {
        changeTag() {
            this.$emit("reg")
        },
        changeEye() {
            this.isEye = !this.isEye
        },
        changeRemember() {
            this.isRemember = !this.isRemember
        },
        nameFocus() {
            this.$refs.loginname.focus()
            this.namefocus = true
            // this.checkName()
        },
        nameBlur() {
            this.namefocus = false
            this.checkName()
        },
        nameInput() {
            this.checkName()
        },
        checkName(needResult = false) {
            // if(this.loginname.length <= 0)
            // {
            //     if(needResult) {
            //         return false
            //     }
            //     this.nameempty = true
            //     this.nameerror = true
            // this.nameinfo = this.GLOBAL.lanLocal['plzinput']
            // } else if (this.loginname.length > 12 || this.loginname.length < 8) {
            //     if(needResult) {
            //         return false
            //     }
            //     this.nameempty = false
            //     this.nameerror = true
            // this.nameinfo = this.GLOBAL.lanLocal['rightphone']
            // }else {
            if (needResult) {
                return true
            }
            this.nameempty = false
            this.nameerror = false
            this.nameinfo = ''
            // }
        },
        passcodeFocus() {
            this.$refs.passcode.focus()
            this.passcodefocus = true
            // this.checkPasscode()
        },
        passcodeBlur() {
            this.passcodefocus = false
            this.checkPasscode()
        },
        passcodeInput() {
            this.checkPasscode()
        },
        checkPasscode(needResult = false) {
            if (this.passcode.length <= 0) {
                if (needResult) {
                    return false
                }
                this.passcodeempty = true
                this.passcodeerror = true
                this.passcodeinfo = this.GLOBAL.lanLocal['plzinput']
            } else if (this.passcode.length < 6) {
                if (needResult) {
                    return false
                }
                this.passcodeempty = false
                this.passcodeerror = true
                this.passcodeinfo = this.GLOBAL.lanLocal['sixpasscode']
            } else {
                if (needResult) {
                    return true
                }
                this.passcodeempty = false
                this.passcodeerror = false
                this.passcodeinfo = ''
            }
        },
        doLogin() {
            let that = this
            if (this.checkName(true) && this.checkPasscode(true)) {
                const passcode = md5(this.passcode)
                doPost({
                    n: 'AppGame',
                    a: 'do_login',
                    mobile: this.loginname,
                    password: passcode
                }).then((res) => {
                    if (res.code === 0) {
                        const json = loadFile("static/nonce", true);
                        if (json != null) {
                            let api_aes_key = json['api_aes_key']
                            localStorage.setItem(md5('__name__'), AES.encrypt(this.loginname, api_aes_key))
                            localStorage.setItem(md5('__pwd_'), AES.encrypt(passcode, api_aes_key))

                            this.GLOBAL.userInfo.name = this.loginname
                            this.GLOBAL.userInfo.passcode = passcode

                            that.$emit('reload');
                        }
                    } else {
                        const data = decodeApiLan(res, this.GLOBAL.lanArr);
                        this.$toast.error(data.message, {
                            position: "top-center",
                            timeout: 2000,
                            closeOnClick: true,
                            pauseOnFocusLoss: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 0.6,
                            showCloseButtonOnHover: false,
                            hideProgressBar: true,
                            closeButton: false,
                            icon: true,
                            rtl: false
                        });
                    }
                })
            }
        },
        toSignup() {
            this.$emit('toSignup')
        },
        toForgot() {
            this.$emit('toForgot')
        }
    }
};
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.main-page {
    height: 100%;
    width: 100%;
    padding: 12px 12px 80px;
    background-image: url('../../assets/login/bg.jpg');
    background-size: 100% 100%;
    text-align: center;
    box-sizing: border-box;
}

.login-logo {
    padding-top: 2.2rem;
    margin-bottom: 1.8rem;
    text-align: center;
}

.login-logo-img {
    width: 211px;
    height: auto;
}

.tag-box {
    height: 48px;
    margin: 0 20px 2.2rem;
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 6px;
    display: flex;
    align-items: center;

    .tag-left,
    .tag-right {
        font-size: 15px;
        flex: 1;
        color: #fff;
    }

    .tag-split {
        height: 16px;
        width: auto;
    }

    .tag-active {
        color: rgb(255, 182, 0);
    }
}

.login-info-item {
    text-align: left;
    margin: 0 40px 4px 40px;
    background: rgba(100, 100, 100, 0.5);
    height: 40px;
    border-radius: 6px;
    position: relative;
    color: #fff;
}

.eye-img {
    height: 20px;
    width: 20px;
}

.button-box {
    margin-top: 24px;
}

.v-label {
    position: absolute;
    left: 20px;
    font-size: 16px;
    top: 17px;
    height: 20px;
    line-height: 20px;
    letter-spacing: normal;
    -webkit-animation: v-shake .6s cubic-bezier(.25, .8, .5, 1);
    animation: v-shake .6s cubic-bezier(.25, .8, .5, 1);
    transform-origin: top left;
}

.v-input {
    width: auto;
    color: #fff;
    background: transparent;
    padding: 0 16px;
    border: 0;
    font-size: 16px;
    height: 40px;
    line-height: 40px;
    letter-spacing: normal;
}

.v-input::placeholder {
    color: #f3f3f3;
}

.login-info-item input:focus {
    outline: none;
}

.msg-box {
    min-height: 20px;
    overflow: hidden;
    margin: 0 40px;
    position: relative;
}

.login-info-message {
    min-height: 14px;
    padding: 0 12px;
    color: #fff;
    line-height: 12px;
    word-break: break-word;
    word-wrap: break-word;
    -webkit-hyphens: auto;
    -ms-hyphens: auto;
    hyphens: auto;
    font-size: 12px;
    text-align: left;
}

.bar-box {
    margin-top: 6px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 40px;
    box-sizing: border-box;

    .left-box {
        display: flex;
        align-items: center;

        .remember-img {
            height: 20px;
            width: 20px;
            margin-right: 4px;
        }

        .keep-login {
            font-size: 12px;
            color: #fff;
        }
    }

    .forget-passcode {
        font-size: 12px;
        color: rgb(255, 182, 0);
    }
}

.error-info {
    color: #dd2c00 !important;
    caret-color: #dd2c00 !important;
}

.normal-info {
    color: #1976d2 !important;
    caret-color: #1976d2 !important;
}

.theme-dark {
    color: #fff;
}

.v-icon {
    position: absolute;
    right: 20px;
    top: 0;
    height: 40px;
    display: flex;
    align-items: center;
}

.v-label-active {
    transform: translateY(-10px) scale(.75);
}

@-webkit-keyframes v-shake {
    59% {
        margin-left: 0
    }

    60%,
    80% {
        margin-left: 2px
    }

    70%,
    90% {
        margin-left: -2px
    }
}

@keyframes v-shake {
    59% {
        margin-left: 0
    }

    60%,
    80% {
        margin-left: 2px
    }

    70%,
    90% {
        margin-left: -2px
    }
}

.login-button {
    background: rgb(255, 182, 0);
    color: #333 !important;
    font-weight: 600;
    height: 44px;
    min-width: 66.66666%;
    padding: 0 19.5555555556px;
    font-size: 18px !important;
    letter-spacing: 0 !important;
    border-radius: 6px !important;
    transition: all .2s cubic-bezier(.02, .54, .58, 1);
    border: none;
    font-family: Noto Sans Thai;
    padding: 0 20px;
}

.reg-info {
    .page-title {
        position: relative;
        font-weight: 500;
        font-size: 18px;

        .close {
            color: #fff;
            position: absolute;
            top: 0;
            right: 0;

            .v-icon {
                top: 0 !important;
                right: 0 !important;
                align-items: center;
                display: inline-flex;
                font-feature-settings: "liga";
                font-size: 24px;
                justify-content: center;
                letter-spacing: normal;
                line-height: 1;
                position: relative;
                text-indent: 0;
                transition: .3s cubic-bezier(.25, .8, .5, 1), visibility 0s;
                vertical-align: middle;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
            }
        }
    }

    .login-logo {
        padding-top: 1rem;
        margin-bottom: 1rem;
        text-align: center;
    }

    .login-logo-img {
        width: 250px;
        height: auto;
    }

    .login-info-item {
        text-align: left;
        margin: 0 32px 4px 32px;
        background: hsla(0, 0%, 100%, .08);
        height: 52px;
        border-radius: 32px;
        position: relative;
        color: hsla(0, 0%, 100%, .7);
    }

    .v-label {
        position: absolute;
        left: 20px;
        font-size: 16px;
        top: 17px;
        height: 20px;
        line-height: 20px;
        letter-spacing: normal;
        -webkit-animation: v-shake .6s cubic-bezier(.25, .8, .5, 1);
        animation: v-shake .6s cubic-bezier(.25, .8, .5, 1);
        transform-origin: top left;
    }

    .v-input {
        width: auto;
        color: #fff;
        background: transparent;
        margin-top: 22px;
        padding: 0 20px;
        border: 0;
        font-size: 16px;
        height: 20px;
        line-height: 20px;
        letter-spacing: normal;
    }

    .d-flex {
        display: flex !important;
        margin: 0 32px;
        padding-bottom: 12px;

        .v-input-box {
            align-items: flex-start;
            display: flex;
            font-size: 16px;
            letter-spacing: normal;
            max-width: 100%;
            text-align: left;
            flex: 0 1 auto;
            margin-top: 5px;
            padding-top: 5px;

            .v-input__control {
                display: flex;
                flex-direction: column;
                height: auto;
                flex-grow: 1;
                flex-wrap: wrap;
                min-width: 0;
                width: 100%;

                .v-input__slot {
                    align-items: center;
                    color: inherit;
                    display: flex;
                    margin-bottom: 8px;
                    min-height: inherit;
                    position: relative;
                    transition: .3s cubic-bezier(.25, .8, .5, 1);
                    width: 100%;
                    cursor: pointer;

                    .v-input--selection-controls__input {
                        color: inherit;
                        display: inline-flex;
                        flex: 0 0 auto;
                        height: 24px;
                        position: relative;
                        transition: .3s cubic-bezier(.25, .8, .5, 1);
                        transition-property: transform;
                        width: 24px;
                        -webkit-user-select: none;
                        -moz-user-select: none;
                        -ms-user-select: none;
                        user-select: none;
                        margin-right: 8px;

                        .v-icon {
                            align-items: center;
                            display: inline-flex;
                            font-feature-settings: "liga";
                            font-size: 24px;
                            justify-content: center;
                            letter-spacing: normal;
                            line-height: 1;
                            position: relative;
                            text-indent: 0;
                            transition: .3s cubic-bezier(.25, .8, .5, 1), visibility 0s;
                            vertical-align: middle;
                            -webkit-user-select: none;
                            -moz-user-select: none;
                            -ms-user-select: none;
                            user-select: none;
                            width: 100%;
                        }

                        .primary--text {
                            color: #1976d2 !important;
                            caret-color: #1976d2 !important;
                        }

                        .mdi:before {
                            content: "\F0131";
                            display: inline-block;
                            font: normal normal normal 24px/1 Material Design Icons;
                            font-size: inherit;
                            text-rendering: auto;
                            line-height: inherit;
                            -webkit-font-smoothing: antialiased;
                            -moz-osx-font-smoothing: grayscale;
                        }

                        .v-icon.v-icon:after {
                            background-color: currentColor;
                            border-radius: 50%;
                            content: "";
                            display: inline-block;
                            height: 100%;
                            left: 0;
                            opacity: 0;
                            pointer-events: none;
                            position: absolute;
                            top: 0;
                            transform: scale(1.3);
                            width: 100%;
                            transition: opacity .2s cubic-bezier(.4, 0, .6, 1);
                        }

                        .v-input--selection-controls__ripple {
                            border-radius: 50%;
                            cursor: pointer;
                            height: 34px;
                            position: absolute;
                            transition: inherit;
                            width: 34px;
                            left: -12px;
                            top: calc(50% - 24px);
                            margin: 7px;
                        }

                        .v-input--selection-controls__ripple:before {
                            border-radius: inherit;
                            bottom: 0;
                            content: "";
                            position: absolute;
                            opacity: .2;
                            left: 0;
                            right: 0;
                            top: 0;
                            transform-origin: center center;
                            transform: scale(.2);
                            transition: inherit;
                        }
                    }
                }
            }
        }

        .more-information {
            color: #fff;

            >span {
                background: linear-gradient(180deg, #ffdf46, #ffdc42 23.96%, #feeb52 49.48%, #fbc316 71.87%, #f69b09);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
                font-weight: 600;
                cursor: pointer;
            }
        }
    }

    .login-info-item input:focus {
        outline: none;
    }

    .msg-box {
        min-height: 20px;
        overflow: hidden;
        margin: 0 32px;
        position: relative;
    }

    .login-info-message {
        min-height: 14px;
        padding: 0 12px;
        color: #fff;
        line-height: 12px;
        word-break: break-word;
        word-wrap: break-word;
        -webkit-hyphens: auto;
        -ms-hyphens: auto;
        hyphens: auto;
        font-size: 12px;
        text-align: left;
    }

    .forget-passcode {
        word-break: break-word;
        word-wrap: break-word;
        -webkit-hyphens: auto;
        -ms-hyphens: auto;
        hyphens: auto;
        font-size: 14px;
        position: absolute;
        right: 1.5rem;
        bottom: 0;
        color: #fff;
    }

    .error-info {
        color: #dd2c00 !important;
        caret-color: #dd2c00 !important;
    }

    .normal-info {
        color: #1976d2 !important;
        caret-color: #1976d2 !important;
    }

    .theme-dark {
        color: #fff;
    }

    .v-icon {
        position: absolute;
        right: 20px;
        top: 15px;
        font-size: 16px;
    }

    .v-label-active {
        transform: translateY(-10px) scale(.75);
    }

    .protocal {
        position: fixed;
        top: 0;
        left: 0;
        display: none;
        background-color: #000 !important;
        color: white;
        font-family: Noto Sans Thai, Roboto !important;
        font-size: 14px !important;
        text-align: left;
        height: 100%;
        align-items: center;

        .container {
            width: 100%;
            padding: 12px;
            margin-right: auto;
            margin-left: auto;
            box-sizing: border-box;

            .text-center {
                text-align: center !important;
            }
        }
    }

    .protocal-show {
        display: flex !important;
        ;
    }

    .row {
        display: flex;
        flex-wrap: wrap;
        flex: 1 1 auto;
        margin: -12px;
        margin-top: 12px;

        .dailog-notuser-register {
            color: #fff !important;
            text-align: center;
            margin-bottom: 1rem;

            >a {
                font-size: 17px;
                color: #fff !important;
                text-decoration: underline;
            }
        }

        .col-12 {
            width: 100%;
            padding: 0;
            padding-top: 0 !important;
            padding-bottom: 0 !important;
            justify-content: center;
            flex: 0 0 100%;
            max-width: 100%;
        }

        .dailog-call-center {
            display: flex;
            color: #fff !important;
            text-align: center;
            margin-bottom: 1rem;

            >a {
                font-size: 14px;
                text-decoration: none;
                display: flex;
                cursor: pointer;

                >div {
                    margin: 0 10px;
                    color: #ffd600;
                }

                >img {
                    width: 25px;
                    height: 25px;
                }
            }
        }
    }

    @-webkit-keyframes v-shake {
        59% {
            margin-left: 0
        }

        60%,
        80% {
            margin-left: 2px
        }

        70%,
        90% {
            margin-left: -2px
        }
    }

    @keyframes v-shake {
        59% {
            margin-left: 0
        }

        60%,
        80% {
            margin-left: 2px
        }

        70%,
        90% {
            margin-left: -2px
        }
    }

    .login-button {
        background: linear-gradient(180deg, #ffdf46, #ffdc42 23.96%, #feeb52 49.48%, #fbc316 71.87%, #f69b09);
        color: #212121 !important;
        font-weight: 700;
        box-shadow: 0 4px 4px rgba(0, 0, 0, .25);
        height: 44px;
        min-width: 66.66666%;
        padding: 0 19.5555555556px;
        font-size: 16px !important;
        letter-spacing: 0 !important;
        border-radius: 27px !important;
        transition: all .2s cubic-bezier(.02, .54, .58, 1);
        border: none;
        font-family: Noto Sans Thai;
        padding: 0 20px;
    }

    .login-button-disable {
        background-color: hsla(0, 0%, 100%, .12) !important;
        text-shadow: 0 0 #000;
        opacity: .5 !important;
        color: hsla(0, 0%, 100%, .3) !important;
    }

    .input-disabled {
        color: #dcdcdc;
    }
}
</style>
  


// WEBPACK FOOTER //
// src/components/login/login.vue